$(document).ready(function() {
  var pickupLabel = "Customer Pick-Up at Ottawa Store?"; // the text of the label
  var buttonArea = $('.cart .cart__additional_checkout'); // where to insert the option
  var pickupVariantId = 16432115329; // the variant ID of the local pickup product


  Shopify.getCart(function(cart) {
    var inCart = false;
    $.each(cart.items, function(index, item) {
      if (item.variant_id == pickupVariantId) {
        inCart = true;
        return false;
      }
    });
    buttonArea.append('<div style="color: #ed1c24;" style="text-align: right; margin-top: 15px;"><label for="local-pickup" style="padding: 5px; border: 1px solid #000;"><input id="local-pickup" type="checkbox"' + (inCart ? ' checked' : '') + ' /> ' + pickupLabel + '</label></div>');
  });

  buttonArea.on('change', '#local-pickup', function() {
    if ($(this).is(':checked')) {
      Shopify.addItem(pickupVariantId, 1, function(item) {
        location.reload();
      });
    } else {
      Shopify.changeItem(pickupVariantId, 0, function(cart) {
        location.reload();
      });
    }
  });

});